import { apiClient } from '@/api';

export interface KycStatusResponse {
  success: boolean;
  message?: string;
  kyc_status: boolean;
  kyc_code?: number;
  basic_status: number;  // 0=Yellow, 1=Orange, 2=Green, 3=Red
  bank_status: number;
  business_status: number;
}

export interface BasicDetails {
  name: string;
  email: string;
  phone_number: string;
  company_name: string;
  entity: string;
  address: string;
  state: string;
  city: string;
  pincode: string;
}

export interface BankDetails {
  bank_name: string;
  acc_holder_name: string;
  ifsc: string;
  branch: string;
  merchant_bank_number: string;
  bank_proof?: string;
  attachment_uuid?: string;
}

export interface BusinessDetails {
  pan: string;
  gstin: string;
  attachment_uuid?: string;
  business_proof?: string;
  certificate_of_incorporation?: string;
  company_pan?: string;
  gst_certificate?: string;
  directors_pan_voter_id?: string;
  board_resolution?: string;
  aadhaar_number?: string;
  aadhaar_document?: string;
  declaration_beneficial_ownership?: string;
}

export const profileService = {
  // KYC / verification status
  getKycStatus: () => apiClient.get<KycStatusResponse>('/merchant/v1/kyc_status/'),

  // Basic Details
  getBasicDetails: () => apiClient.get<BasicDetails>('/merchant/v1/basic-details/'),
  updateBasicDetails: (data: FormData) => apiClient.patch('/merchant/v1/basic-details/', data),

  // Bank Details
  getBankDetails: () => apiClient.get<BankDetails>('/merchant/v1/bank-details/'),
  updateBankDetails: (data: FormData) => apiClient.patch('/merchant/v1/bank-details/', data),

  // Business Details
  getBusinessDetails: () => apiClient.get<BusinessDetails>('/merchant/v1/business-details/'),
  updateBusinessDetails: (data: FormData) => apiClient.patch('/merchant/v1/business-details/', data),

  
  // Upload Document

  uploadDocument: (data: FormData) => apiClient.post('/merchant/v1/upload-document/', data, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  }),
  

};